export default __webpack_public_path__ + "static/media/4. Foundation of Love Graphic.01bc3351.pdf";